/**
 * Reactive session-scoped store for whether the patient chat widget is
 * completely hidden (eye-off). Profile can call `setChatHidden(false)`
 * to restore the launcher without a page refresh; the widget subscribes
 * via `useChatHidden()` and re-renders instantly.
 *
 * Persists to sessionStorage under `chat_widget_hidden`.
 */
import { useSyncExternalStore } from "react";

const KEY = "chat_widget_hidden";

function readInitial() {
  if (typeof window === "undefined") return false;
  try { return sessionStorage.getItem(KEY) === "1"; } catch { return false; }
}

let hidden = readInitial();
const listeners = new Set();

export function getChatHidden() {
  return hidden;
}

export function setChatHidden(next) {
  hidden = !!next;
  try {
    if (hidden) sessionStorage.setItem(KEY, "1");
    else sessionStorage.removeItem(KEY);
  } catch { /* SSR / disabled storage */ }
  listeners.forEach((l) => l());
}

function subscribe(listener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function useChatHidden() {
  return useSyncExternalStore(subscribe, getChatHidden, getChatHidden);
}
